import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="border-b border-line bg-canvas" data-id="element-86" data-mp="ehtjbwhet1nt">
      <div className="mx-auto max-w-3xl px-4 pb-8 pt-5 text-center sm:pt-8" data-id="element-87" data-mp="9k0bkz0gjzlf">
        <p className="font-display text-xs font-semibold uppercase tracking-wide text-accent sm:text-sm" data-id="element-88" data-mp="4lyswf6y22ah">
          ⚡ Método de aprendizaje paso a paso
        </p>
        <h1 className="mt-2 font-display text-[1.6rem] font-extrabold leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-89" data-mp="127eeddqu7pdg">
          El sistema completo para aprender{' '}
          <span className="text-accent" data-id="element-90" data-mp="sa9slf0wlvx6">
            cercos eléctricos y seguridad perimetral
          </span>{' '}
          desde cero
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-snug text-muted sm:text-base" data-id="element-91" data-mp="nekkuoeqd8ps">
          Aprende a diseñar, instalar, configurar, probar y mantener sistemas de
          cerco eléctrico perimetral y prepárate para convertir este
          conocimiento en una nueva habilidad técnica — sin perderte entre
          cientos de videos, componentes y tutoriales.
        </p>

        <p className="mt-4 rounded-lg bg-accent px-3 py-2 font-display text-[0.7rem] font-extrabold uppercase leading-tight text-canvas sm:text-sm" data-id="element-92" data-mp="3o5j3nbh1flmc">
          ⚡ {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mt-3 block overflow-hidden rounded-2xl border-2 border-accent/60 transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-93" data-mp="3eb8zyxmnb0wb">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-94" data-mp="2qkwiow5ifrt2" />
        </a>

        <CtaBlock note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-95" data-mp="2hincgih9yklh" />
      </div>
    </header>;
}